module.exports = __webpack_public_path__ + "img/icons BFr_15.763e6d0e.png";